:host {
  display: block;
  cursor: pointer;
}

:host(.aligned-center) {
  align-self: center;
}
:host(.inline) {
  display: inline;
}
:host(.mb-20) {
  margin-bottom: 1.25rem;
}
:host(.teaser) {
  width: 100%;
  height: 100%;
}

.teaser {
  display: block;
  width: 100%;
  height: 100%;

  .link a {
    display: block;
  }
}

.max-content {
  width: max-content;
}

.link {
  display: inline-block;

  &:hover {
    opacity: 0.7;
  }

  &.nav_link {
    display: block;
  }

  &.block {
    display: block;
  }

  &.reset {
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    color: inherit !important;

    a,
    a > span {
      font-size: inherit !important;
      font-weight: inherit !important;
      line-height: inherit !important;
      color: inherit !important;
    }
  }

  a {
    display: flex;
    align-items: baseline;
    text-decoration: none;

    span {
      &.icon {
        font-family: var(--primary-icon-font);
        margin-right: 5px;
        line-height: 1;
      }

      &.text {
        margin-right: 5px;
        font-family: var(--primary-font);
        transform: translateY(-1px);

        &.bold {
          transform: translateY(-2px);
        }

        &.font-minus-4 {
          font-size: calc(var(--selected-font-size) - 4px);
        }

        &.underline {
          text-decoration: underline;
        }

        &.uppercase {
          text-transform: uppercase;
        }

        &.inline {
          margin: 0;
        }

        &.bright,
        a {
          color: var(--link-color-bright);
        }

        &.dark {
          color: var(--link-color-dark);
        }
      }

      &.nav_link {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        @media (max-width: 991px) {
          font-weight: var(--nav_link-font-weight);
          font-size: var(--nav_link-font-size);
        }

        &:hover,
        &.isSelected {
          color: var(--nav_link-color-selected);
        }
      }
    }
  }

  @include supportedTypography();
  @include supportedColors();

  &.header__link {
    span {
      &.text {
        display: none;

        @media (min-width: 1280px) {
          display: inline-block;
        }
      }
    }
  }

  &.hide-mobile {
    display: none;

    @media (min-width: 768px) {
      display: inline-block;
    }
  }

  ::slotted(lilu-img) {
    min-width: 100px;
  }
}

.link.side-menu {
  display: block;
  padding: 12px 20px;

  &.isSelected {
    background-color: var(--color-bleached-silk);
  }

  &:not(.isSelected) {
    a span.text:hover {
      color: var(--color-silver);
    }
  }
}
